<template>

    <div
        class="container px-4 px-xxl-5 mt-5"
    >

        <div>

            <div class="col-12 mb-5 pb-5 w-100" style="max-width: 1000px;">

                <p class="align-control mx-auto h4 font-italic px-0 pt-4 pb-2 mb-4" style="opacity:.5" v-html="$root.translateStringRecycling('table-title-2', lang)"></p>

                <template v-for="(element, index) in nutritionals">

                    <div class="table-mobile d-flex flex-column w-100 mx-auto mb-5 d-xl-none px-2">

                        <div class="title-block p-3 bg-lightgold text-center bg-black mb-4">
                            <span class="h6 text-primary text-uppercase d-block fw-normal p-0 m-0">
                                <span class="text-black">{{ element.label[lang] }}</span>
                            </span>
                        </div>

                        <template v-if="index != 'valore_energetico'">

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">85 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">{{ nutritionalInformations.dichiarazione_nutrizionale[index] ? nutritionalInformations.dichiarazione_nutrizionale[index][85] : 0 }} g</span>
                                </div>
                            </div>

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">100 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">{{ nutritionalInformations.dichiarazione_nutrizionale[index] ? nutritionalInformations.dichiarazione_nutrizionale[index][100] : 0 }} g</span>
                                </div>
                            </div>

                        </template>

                        <template v-else>
                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">85 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">
                                        E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kcal'] }} Kcal
                                    </span>
                                </div>
                            </div>

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">100 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">
                                        E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kcal'] }} Kcal
                                    </span>
                                </div>
                            </div>
                        </template>

                    </div>

                </template>

                <div class="position-relative w-100 px-2 table-mobile mx-auto pt-3 d-xl-none">
                    <div class="p-3 border d-flex align-items-center flex-column">
                        <span class="pb-2">
                            {{ grado_alcolico.label[lang] }}
                        </span>
                        <span class="text-secondary">
                            {{ nutritionalInformations.dichiarazione_nutrizionale.grado_alcolico ?? 0 }} %VOL
                        </span>
                    </div>
                </div>

                <p class="align-control mx-auto h4 font-italic px-0 pt-2 mt-5 mb-2 d-xl-none" style="opacity:.5" v-html="$root.translateStringRecycling('table-title-3', lang)"></p>

                <div class="position-relative w-100 px-2 table-mobile mx-auto pt-3 d-xl-none">

                    <div class="p-4 border d-flex align-items-center flex-column mb-5">
                       <ul class="ps-0 w-100 mb-0">
                        <template v-for="(el, index) in nutritionalInformations.ingredienti">

                            <template v-if="el != null && Array.isArray(el)">

                                <li class="d-flex py-1">
                                    <span class="flex-shrink-0 text-gold pe-2 position-relative">
                                        <h3 style="line-height: 1;">&bull;</h3>
                                    </span>
                                    <span class="pt-1">
                                        {{ ingredients[index].label[lang] }}: {{ makeList(el) }}
                                    </span>
                                </li>

                            </template>

                            <li v-else-if="el != null && el.key" class="d-flex py-1">
                                <span class="flex-shrink-0 text-gold pe-2 position-relative">
                                    <h3 style="line-height: 1;">&bull;</h3>
                                </span>
                                <span class="pt-1">
                                    {{ ingredients[index].label[lang] }}
                                </span>
                            </li>

                        </template>

                       </ul>
                    </div>

                </div>

                <!-- DESKTOP -->

                <table class="table table-striped mx-auto d-none d-xl-table" style="max-width: 1000px">
                    <thead>
                        <tr>
                            <th scope="col" colspan="2" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white text-uppercase font-weight-light"></span>
                                </span>
                            </th>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white font-weight-light">85 g/ml</span>
                                </span>
                            </th>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white font-weight-light">100 g/ml</span>
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(element, index) in nutritionals">
                            <tr class="">
                                <td class="text-center py-3" colspan="2">
                                    <span class="h6 text-primary d-block fw-normal">
                                        <span class="text-black">
                                            {{ element.label[lang] }}
                                        </span>
                                    </span>
                                </td>
                                <template v-if="index != 'valore_energetico'">
                                    <td class="text-center py-4">
                                        <span class="text-secondary">
                                            {{ nutritionalInformations.dichiarazione_nutrizionale[index] ? nutritionalInformations.dichiarazione_nutrizionale[index][85] : 0 }} g
                                        </span>
                                    </td>
                                    <td class="text-center py-4">
                                        <span class="text-secondary">
                                            {{ nutritionalInformations.dichiarazione_nutrizionale[index] ? nutritionalInformations.dichiarazione_nutrizionale[index][100] : 0 }} g
                                        </span>
                                    </td>
                                </template>

                                <template v-else>
                                    <td class="text-center py-4">
                                        <span class="text-secondary">
                                            E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kcal'] }} Kcal
                                        </span>
                                    </td>
                                    <td class="text-center py-4">
                                        <span class="text-secondary">
                                            E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kcal'] }} Kcal
                                        </span>
                                    </td>
                                </template>

                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="position-relative w-100 mx-auto pt-3 mt-5 d-none d-xl-block" style="max-width: 1000px;">
                    <div class="px-5 py-4 border d-flex align-items-center justify-content-between font-normalized text-white">
                        <span class="py-2">
                            {{ grado_alcolico.label[lang] }}
                        </span>
                        <span class="py-2 text-secondary">
                            {{ nutritionalInformations.dichiarazione_nutrizionale.grado_alcolico ?? 0 }} %VOL
                        </span>
                    </div>
                </div>

                <p class="align-control mx-auto h4 font-italic px-0 pt-5 mt-5 mb-3 d-none d-xl-block" style="opacity:.5" v-html="$root.translateStringRecycling('table-title-3', lang)"></p>

                <div class="position-relative w-100 mx-auto pt-3 d-none d-xl-block" style="max-width: 1000px;">

                    <div class="p-4 border d-flex align-items-center flex-column mb-5">
                       <ul class="ps-0 w-100 mb-0 p-3">
                        <template v-for="(el, index) in nutritionalInformations.ingredienti">

                            <template v-if="el != null && Array.isArray(el)">

                                <li class="d-flex py-1 font-normalized text-white">
                                    <span class="flex-shrink-0 text-gold pe-2 position-relative">
                                        <h3 style="line-height: 1;" class="mb-0">&bull;</h3>
                                    </span>
                                    <span class="pt-2" >
                                        {{ ingredients[index].label[lang] }}: {{ makeList(el) }}
                                    </span>
                                </li>

                            </template>

                            <li v-else-if="el != null && el.key" class="d-flex py-1 font-normalized text-white">
                                <span class="flex-shrink-0 text-gold pe-2 position-relative">
                                    <h3 style="line-height: 1;" class="mb-0">&bull;</h3>
                                </span>
                                <span class="pt-2" >
                                    {{ ingredients[index].label[lang] }}
                                </span>
                            </li>

                        </template>

                       </ul>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

    export default {
        props: ['lang', 'product', 'combinationId'],
        data() {
            return {
                grado_alcolico: {
                    label: {
                        it: 'GRADO ALCOLICO',
                        en: 'ALCOHOL LEVEL',
                        de: 'ALKOHOLISCHER INHALT',
                        fr: 'DEGRÉ ALCOOLIQUE',
                        bg: 'АЛКОХОЛНО НИВО', // Bulgaro
                        cs: 'ALKOHOLOVÁ ÚROVEŇ', // Ceco
                        hr: 'ALKOHOLSKI NIVO', // Croato
                        da: 'ALKOHOLINDHOLD', // Danese
                        et: 'ALKOOLITASE', // Estone
                        fi: 'ALKOOLIPROSENTTI', // Finlandese
                        el: 'ΕΠΙΠΤΩΣΗ ΑΛΚΟΟΛΙΚΟΥ', // Greco
                        ga: 'LEIRCHÁIDAL ALCOIL', // Irlandese
                        lv: 'ALKOHOLA LIKME', // Lettone
                        lt: 'ALKOHOLIO LYGIS', // Lituano
                        mt: 'LIVEL ALKOLOĊJIK', // Maltese
                        nl: 'ALCOHOLGEHALTE', // Neerlandese
                        pl: 'POZIOM ALKOHOLU', // Polacco
                        pt: 'NÍVEL DE ÁLCOOL', // Portoghese
                        ro: 'NIVELUL DE ALCOOL', // Rumeno
                        sk: 'ALKOHOLOVÝ OBSAH', // Slovacco
                        sl: 'ALKOHOLNA VOSEBINA', // Sloveno
                        es: 'NIVEL DE ALCOHOL', // Spagnolo
                        sv: 'ALKOHOLNIVÅ', // Svedese
                        hu: 'ALKOHOLSZINT' // Ungherese
                    },
                },
                nutritionals: {
                    valore_energetico: {
                        label: {
                            it: 'VALORE ENERGETICO',
                            en: 'ENERGY VALUE',
                            de: 'ENERGIEWERT',
                            fr: 'VALEUR ÉNERGÉTIQUE',
                            bg: 'ЕНЕРГЕТСКА СТОЙНОСТ', // Bulgaro
                            cs: 'ENERGETICKÁ HODNOTA', // Ceco
                            hr: 'ENERGETSKA VRIJEDNOST', // Croato
                            da: 'ENERGI', // Danese
                            et: 'ENERGIA VÄÄRTUS', // Estone
                            fi: 'ENERGIOARVO', // Finlandese
                            el: 'ΕΝΕΡΓΕΙΑΚΗ ΑΞΙΑ', // Greco
                            ga: 'LUACH FOIRME OILGEID', // Irlandese
                            lv: 'ENERĢETISKĀ VĒRTĪBA', // Lettone
                            lt: 'ENERGĖTINĖ VERTĖ', // Lituano
                            mt: 'VALUR ENERGĒTIK', // Maltese
                            nl: 'ENERGIEWAARDE', // Neerlandese
                            pl: 'WARTOŚĆ ENERGETYCZNA', // Polacco
                            pt: 'VALOR ENERGÉTICO', // Portoghese
                            ro: 'VALOARE ENERGETICĂ', // Rumeno
                            sk: 'ENERGETICKÁ HODNOTA', // Slovacco
                            sl: 'ENERGETSKA VREDNOST', // Sloveno
                            es: 'VALOR ENERGÉTICO', // Spagnolo
                            sv: 'ENERGIVÄRDE', // Svedese
                            hu: 'ENERGIAI ÉRTÉK' // Ungherese
                        },
                    },
                    grassi: {
                        label: {
                            it: 'GRASSI',
                            en: 'FATS',
                            de: 'FETTE',
                            fr: 'GRAISSES',
                            bg: 'МАЗНИНИ', // Bulgaro
                            cs: 'TUKY', // Ceco
                            hr: 'MASTI', // Croato
                            da: 'FEDT', // Danese
                            et: 'RASVAD', // Estone
                            fi: 'RASVAT', // Finlandese
                            el: 'ΛΙΠΑΡΑ', // Greco
                            ga: 'SAILL', // Irlandese
                            lv: 'TAUKI', // Lettone
                            lt: 'RIEBALAI', // Lituano
                            mt: 'FJETTI', // Maltese
                            nl: 'VETTEN', // Neerlandese
                            pl: 'TŁUSZCZE', // Polacco
                            pt: 'GORDURAS', // Portoghese
                            ro: 'GRĂSIMI', // Rumeno
                            sk: 'TUKY', // Slovacco
                            sl: 'MASTE', // Sloveno
                            es: 'GRASAS', // Spagnolo
                            sv: 'FETT', // Svedese
                            hu: 'ZSÍROK' // Ungherese
                        },
                    },
                    grassi_saturi: {
                        label: {
                            it: 'di cui acidi grassi saturi',
                            en: 'of which saturated fats',
                            de: 'davon gesättigte Fettsäuren',
                            fr: 'dont acides gras saturés',
                            bg: 'съдържащи наситени мастни киселини', // Bulgaro
                            cs: 'z toho nasycené tuky', // Ceco
                            hr: 'od kojih zasićene masti', // Croato
                            da: 'heraf mættede fedtsyrer', // Danese
                            et: 'millest küllastunud rasvad', // Estone
                            fi: 'joista tyydyttyneet rasvat', // Finlandese
                            el: 'από τα οποία κορεσμένα λιπαρά', // Greco
                            ga: 'athar taobh den bhreoscaíí saolta', // Irlandese
                            lv: 'no kuriem piesātinātie tauki', // Lettone
                            lt: 'iš kurių sočiųjų riebalų', // Lituano
                            mt: 'mingħajr fats saturati', // Maltese
                            nl: 'waarvan verzadigde vetzuren', // Neerlandese
                            pl: 'z których tłuszcze nasycone', // Polacco
                            pt: 'dos quais gorduras saturadas', // Portoghese
                            ro: 'dintre care grăsimi saturate', // Rumeno
                            sk: 'z toho nasýtené tuky', // Slovacco
                            sl: 'od katerih nasičene maščobe', // Sloveno
                            es: 'de las cuales grasas saturadas', // Spagnolo
                            sv: 'varav mättat fett', // Svedese
                            hu: 'melyek közül a telített zsírsavak' // Ungherese
                        },
                    },
                    carboidrati: {
                        label: {
                            it: 'CARBOIDRATI',
                            en: 'CARBOHYDRATES',
                            de: 'KOHLENHYDRATE',
                            fr: 'GLUCIDES',
                            bg: 'ВЪГЛЕХИДРАТИ', // Bulgaro
                            cs: 'SACHARIDY', // Ceco
                            hr: 'UGLJIKOHIDRATI', // Croato
                            da: 'KULHYDRAT', // Danese
                            et: 'SÜSIVESID', // Estone
                            fi: 'HIILIHYDRAATIT', // Finlandese
                            el: 'ΥΔΑΤΑΝΘΡΑΚΕΣ', // Greco
                            ga: 'CARBAIHIODRÁIT', // Irlandese
                            lv: 'OGĻHIDRĀTI', // Lettone
                            lt: 'ANGLIAVANDENIAI', // Lituano
                            mt: 'KARBOHĠDAIRATI', // Maltese
                            nl: 'KOOLHYDRATEN', // Neerlandese
                            pl: 'WĘGLOWODANY', // Polacco
                            pt: 'CARBOIDRATOS', // Portoghese
                            ro: 'CARBOHIDRAȚI', // Rumeno
                            sk: 'SACHARIDY', // Slovacco
                            sl: 'OGLJIKOVI HIDRATI', // Sloveno
                            es: 'CARBOHIDRATOS', // Spagnolo
                            sv: 'KOLHYDRATER', // Svedese
                            hu: 'SZÉNHIDRÁT' // Ungherese
                        },
                    },
                    zuccheri: {
                        label: {
                            it: 'di cui zuccheri',
                            en: 'of which sugars',
                            de: 'davon Zucker',
                            fr: 'dont sucres',
                            bg: 'от които захари', // Bulgaro
                            cs: 'z toho cukry', // Ceco
                            hr: 'od kojih šećeri', // Croato
                            da: 'heraf sukkerarter', // Danese
                            et: 'millest suhkrud', // Estone
                            fi: 'joista sokerit', // Finlandese
                            el: 'από τα οποία σάκχαρα', // Greco
                            ga: 'athar taobh na siúcra', // Irlandese
                            lv: 'no kuriem cukuri', // Lettone
                            lt: 'iš kurių cukrūs', // Lituano
                            mt: 'mingħajr ċiriċjir', // Maltese
                            nl: 'waarvan suikers', // Neerlandese
                            pl: 'z których cukry', // Polacco
                            pt: 'dos quais açúcares', // Portoghese
                            ro: 'dintre care zaharuri', // Rumeno
                            sk: 'z toho cukry', // Slovacco
                            sl: 'od katerih sladkorji', // Sloveno
                            es: 'de los cuales azúcares', // Spagnolo
                            sv: 'varav socker', // Svedese
                            hu: 'melyek közül a cukrok' // Ungherese
                        },
                    },
                    proteine: {
                        label: {
                            it: 'PROTEINE',
                            en: 'PROTEINS',
                            de: 'PROTEINE',
                            fr: 'PROTÉINES',
                            bg: 'БЕЛТЪЦИ', // Bulgaro
                            cs: 'BÍLKOVINY', // Ceco
                            hr: 'PROTEINI', // Croato
                            da: 'PROTEINER', // Danese
                            et: 'VALGUD', // Estone
                            fi: 'PROTEIINI', // Finlandese
                            el: 'ΠΡΩΤΕΊΝΕΣ', // Greco
                            ga: 'PRÓITÉIN', // Irlandese
                            lv: 'OLBALTUMVIELAS', // Lettone
                            lt: 'BALTYMAI', // Lituano
                            mt: 'PROTIĠINI', // Maltese
                            nl: 'EIWITTEN', // Neerlandese
                            pl: 'BIAŁKO', // Polacco
                            pt: 'PROTEÍNAS', // Portoghese
                            ro: 'PROTEINE', // Rumeno
                            sk: 'BIELKOVINY', // Slovacco
                            sl: 'BELJAKOVINE', // Sloveno
                            es: 'PROTEÍNAS', // Spagnolo
                            sv: 'PROTEINER', // Svedese
                            hu: 'FEHÉRJE' // Ungherese
                        },
                    },
                    sale: {
                        label: {
                            it: 'SALE',
                            en: 'SALT',
                            de: 'SALZ',
                            fr: 'SEL',
                            bg: 'СОЛ', // Bulgaro
                            cs: 'SŮL', // Ceco
                            hr: 'SOL', // Croato
                            da: 'SALT', // Danese
                            et: 'SOOL', // Estone
                            fi: 'SUOLA', // Finlandese
                            el: 'ΑΛΑΤΙ', // Greco
                            ga: 'SALANN', // Irlandese
                            lv: 'SĀLS', // Lettone
                            lt: 'DRUSKA', // Lituano
                            mt: 'SALTI', // Maltese
                            nl: 'ZOUT', // Neerlandese
                            pl: 'SÓL', // Polacco
                            pt: 'SAL', // Portoghese
                            ro: 'SARE', // Rumeno
                            sk: 'SOĽ', // Slovacco
                            sl: 'SOL', // Sloveno
                            es: 'SAL', // Spagnolo
                            sv: 'SALT', // Svedese
                            hu: 'SÓ' // Ungherese
                        },
                    },
                    acidi_organici: {
                        label: {
                            it: 'ACIDI ORGANICI',
                            en: 'ORGANIC ACIDS',
                            de: 'ORGANISCHE SÄUREN',
                            fr: 'ACIDES ORGANIQUES',
                            bg: 'ОРГАНИЧНИ КИСЕЛИНИ', // Bulgaro
                            cs: 'ORGANICKÉ KYSELINY', // Ceco
                            hr: 'ORGANSKA KISELINE', // Croato
                            da: 'ORGANISKE SYRER', // Danese
                            et: 'ORGAANILISED HAPPED', // Estone
                            fi: 'ORGANISET HAPOT', // Finlandese
                            el: 'ΟΡΓΑΝΙΚΕΣ ΟΞΕΣ', // Greco
                            ga: 'AIGÉID ORGÁNACHA', // Irlandese
                            lv: 'ORGANISKĀS SKĀBES', // Lettone
                            lt: 'ORGANINĖS RŪGŠTYS', // Lituano
                            mt: 'ACĊENTI ORGANIĊI', // Maltese
                            nl: 'ORGANISCHE ZURE', // Neerlandese
                            pl: 'KWASY ORGANICZNE', // Polacco
                            pt: 'ÁCIDOS ORGÂNICOS', // Portoghese
                            ro: 'ACIZI ORGANICE', // Rumeno
                            sk: 'ORGANICKÉ KYSELINY', // Slovacco
                            sl: 'ORGANSKA KISLINE', // Sloveno
                            es: 'ÁCIDOS ORGÁNICOS', // Spagnolo
                            sv: 'ORGANISKA SYROR', // Svedese
                            hu: 'SZERVES SAVAK' // Ungherese
                        },
                    },
                    polioli: {
                        label: {
                            it: 'POLIOLI (GLICERINA)',
                            en: 'POLYOLS (GLYCERINE)',
                            de: 'POLYOLE (GLYCERIN)',
                            fr: 'POLYOLS (GLYCÉRINE)',
                            bg: 'ПОЛИОЛИ (ГЛИСЕРИН)', // Bulgaro
                            cs: 'POLYOLY (GLYCEŘINA)', // Ceco
                            hr: 'POLIOLI (GLIKERIN)', // Croato
                            da: 'POLYOLER (GLYCEROL)', // Danese
                            et: 'POLYOOLID (GLÜSERIN)', // Estone
                            fi: 'POLYOOLIT (GLISEERIINI)', // Finlandese
                            el: 'ΠΟΛΥΟΛΙ (ΓΛΥΚΕΡΙΝΗ)', // Greco
                            ga: 'POLYOLS (GLYCERÍNE)', // Irlandese
                            lv: 'POLIOLI (GLIKERĪNS)', // Lettone
                            lt: 'POLIOLIAI (GLICERINAS)', // Lituano
                            mt: 'POLIOLI (GLIKERINA)', // Maltese
                            nl: 'POLYOLA’S (GLYCERINE)', // Neerlandese
                            pl: 'POLIOLE (GLYCERYNA)', // Polacco
                            pt: 'POLIÓIS (GLICERINA)', // Portoghese
                            ro: 'POLIOLI (GLICERINĂ)', // Rumeno
                            sk: 'POLYOLY (GLICYRÍNA)', // Slovacco
                            sl: 'POLIOLI (GLIKERIN)', // Sloveno
                            es: 'POLIÓLES (GLICERINA)', // Spagnolo
                            sv: 'POLYOLA (GLYCERIN)', // Svedese
                            hu: 'POLIOLOK (GLIKERIN)' // Ungherese
                        },
                    },
                },
                ingredients: {
                    uva: {
                        label: {
                            it: 'Uve',
                            en: 'Grapes',
                            de: 'Trauben',
                            fr: 'Raisins',
                            bg: 'Грозде', // Bulgaro
                            cs: 'Hrozny', // Ceco
                            hr: 'Grožđe', // Croato
                            da: 'Druer', // Danese
                            et: 'Viinamarjad', // Estone
                            fi: 'Rypäleet', // Finlandese
                            el: 'Σταφύλια', // Greco
                            ga: 'Fíon', // Irlandese
                            lv: 'Vīnogas', // Lettone
                            lt: 'Vynuogės', // Lituano
                            mt: 'Vjinojn', // Maltese
                            nl: 'Druiven', // Neerlandese
                            pl: 'Winogrona', // Polacco
                            pt: 'Uvas', // Portoghese
                            ro: 'Struguri', // Rumeno
                            sk: 'Hrozno', // Slovacco
                            sl: 'Grozdje', // Sloveno
                            es: 'Uvas', // Spagnolo
                            sv: 'Druvor', // Svedese
                            hu: 'Szőlő' // Ungherese
                        },
                    },
                    mosto: {
                        label: {
                            it: 'Mosto d’uve concentrato',
                            en: 'Concentrated grape must',
                            de: 'Konzentrierter Traubenmost',
                            fr: 'Moût de raisin concentré',
                            bg: 'Концентриран гроздов сок', // Bulgaro
                            cs: 'Koncentrovaný hroznový mošt', // Ceco
                            hr: 'Koncentrirani mošt od grožđa', // Croato
                            da: 'Koncentreret druemost', // Danese
                            et: 'Konsentreeritud viinamarjamahl', // Estone
                            fi: 'Keskitetty rypälemehu', // Finlandese
                            el: 'Συμπυκνωμένος χυμός σταφυλιού', // Greco
                            ga: 'Muisce crú páir', // Irlandese
                            lv: 'Koncentrēts vīnogu druons', // Lettone
                            lt: 'Koncentruotas vynuogių sultys', // Lituano
                            mt: 'Must intens uva', // Maltese
                            nl: 'Geconcentreerde druivensap', // Neerlandese
                            pl: 'Skoncentrowany moszcz winogronowy', // Polacco
                            pt: 'Mosto de uva concentrado', // Portoghese
                            ro: 'Must de struguri concentrat', // Rumeno
                            sk: 'Koncentrovaný hroznový mošt', // Slovacco
                            sl: 'Koncentriran grozdni mošt', // Sloveno
                            es: 'Mosto de uva concentrado', // Spagnolo
                            sv: 'Koncentrerad druvmust', // Svedese
                            hu: 'Koncentrált szőlőlé' // Ungherese
                        },
                    },
                    mosto_rettificato: {
                        label: {
                            it: 'Mosto d’uve concentrato rettificato',
                            en: 'Rectified concentrated grape must',
                            de: 'Rettifizierter konzentrierter Traubenmost',
                            fr: 'Moût de raisin concentré rectifié',
                            bg: 'Ректифициран концентриран гроздов сок', // Bulgaro
                            cs: 'Rectifikovaný koncentrovaný hroznový mošt', // Ceco
                            hr: 'Rektificirani koncentrirani mošt od grožđa', // Croato
                            da: 'Rektificeret koncentreret druemost', // Danese
                            et: 'Rectifikatsiooniga kontsentreeritud viinamarjamahl', // Estone
                            fi: 'Rektifioitu keskitetty rypälemehu', // Finlandese
                            el: 'Διορθωμένος συμπυκνωμένος χυμός σταφυλιού', // Greco
                            ga: 'Muisce crú páir taitsiú', // Irlandese
                            lv: 'Rectificēts koncentrēts vīnogu druons', // Lettone
                            lt: 'Rectifikavimas koncentruotas vynuogių sultys', // Lituano
                            mt: 'Must intens uva rettifikat', // Maltese
                            nl: 'Gerectificeerd geconcentreerde druivensap', // Neerlandese
                            pl: 'Rettifikowany skoncentrowany moszcz winogronowy', // Polacco
                            pt: 'Mosto de uva concentrado retificado', // Portoghese
                            ro: 'Must de struguri concentrat rectificat', // Rumeno
                            sk: 'Rettifikovaný koncentrovaný hroznový mošt', // Slovacco
                            sl: 'Rektificiran koncentriran grozdni mošt', // Sloveno
                            es: 'Mosto de uva concentrado rectificado', // Spagnolo
                            sv: 'Rektifierad koncentrerad druvmust', // Svedese
                            hu: 'Rektifikált koncentrált szőlőlé' // Ungherese
                        },
                    },
                    saccarosio: {
                        label: {
                            it: 'Saccarosio',
                            en: 'Sucrose',
                            de: 'Saccharose',
                            fr: 'Saccharose',
                            bg: 'САКАРОЗА', // Bulgaro
                            cs: 'SACHAROZA', // Ceco
                            hr: 'Saharoza', // Croato
                            da: 'Saccharose', // Danese
                            et: 'Sahharoos', // Estone
                            fi: 'Sakkaroosi', // Finlandese
                            el: 'ΣΑΧΑΡΟΖΗ', // Greco
                            ga: 'SUCROSE', // Irlandese
                            lv: 'SAHAROZE', // Lettone
                            lt: 'SAHAROZĖ', // Lituano
                            mt: 'SAKKAROŻI', // Maltese
                            nl: 'SACCHAROSE', // Neerlandese
                            pl: 'SACHAROZA', // Polacco
                            pt: 'SACAROSE', // Portoghese
                            ro: 'SACAROZA', // Rumeno
                            sk: 'SACHARÓZA', // Slovacco
                            sl: 'Saharoza', // Sloveno
                            es: 'SACAROSA', // Spagnolo
                            sv: 'SACKAROS', // Svedese
                            hu: 'SZACHARÓZ' // Ungherese
                        },
                    },
                    sciroppo_zuccherino: {
                        label: {
                            it: 'Sciroppo zuccherino',
                            en: 'Sugar syrup',
                            de: 'Zuckersirup',
                            fr: 'Sirop sucré',
                            bg: 'ЗАШАРЕН СИРОП', // Bulgaro
                            cs: 'Cukrový sirup', // Ceco
                            hr: 'Šećerni sirup', // Croato
                            da: 'Sukkersirup', // Danese
                            et: 'Suhkrusirup', // Estone
                            fi: 'Sokerisiirappi', // Finlandese
                            el: 'Ζαχαρωτό σιρόπι', // Greco
                            ga: 'Sir atá faoi rású', // Irlandese
                            lv: 'Cukura sīrups', // Lettone
                            lt: 'Cukraus sirupas', // Lituano
                            mt: 'Sirupa tal-Ċir', // Maltese
                            nl: 'Suikersiroop', // Neerlandese
                            pl: 'Syrop cukrowy', // Polacco
                            pt: 'Xarope de açúcar', // Portoghese
                            ro: 'Sirop de zahăr', // Rumeno
                            sk: 'Cukrový sirup', // Slovacco
                            sl: 'Sladkorni sirup', // Sloveno
                            es: 'Jarabe de azúcar', // Spagnolo
                            sv: 'Sockerlag', // Svedese
                            hu: 'Cukorszirup' // Ungherese
                        },
                    },
                    sciroppo_dosaggio: {
                        label: {
                            it: 'Sciroppo di dosaggio',
                            en: 'Dosage syrup',
                            de: 'Dosiersirup',
                            fr: 'Sirop de dosage',
                            bg: 'СИРОП ЗА ДОЗИРАНЕ', // Bulgaro
                            cs: 'Důbalný sirup', // Ceco
                            hr: 'Sirup za dosiranje', // Croato
                            da: 'Doseringssirup', // Danese
                            et: 'Doosirsirup', // Estone
                            fi: 'Doosisirappi', // Finlandese
                            el: 'Σιρόπι δόσης', // Greco
                            ga: 'Siracha dóisithe', // Irlandese
                            lv: 'Doziersīrups', // Lettone
                            lt: 'Dozavimo sirupas', // Lituano
                            mt: 'Sirupa tad-Dosjar', // Maltese
                            nl: 'Dosissiroop', // Neerlandese
                            pl: 'Syrop dozujący', // Polacco
                            pt: 'Xarope de dosagem', // Portoghese
                            ro: 'Sirop de dozare', // Rumeno
                            sk: 'Dávkovací sirup', // Slovacco
                            sl: 'Dozirni sirup', // Sloveno
                            es: 'Jarabe de dosificación', // Spagnolo
                            sv: 'Doseringssirup', // Svedese
                            hu: 'Adagószirup' // Ungherese
                        },
                    },
                    imbottigliato_atmosfera_protettiva: {
                        label: {
                            it: 'Imbottigliato in atmosfera protettiva',
                            en: 'Bottled in a protective atmosphere',
                            de: 'Unter Schutzatmosphäre abgefüllt',
                            fr: 'Mis en bouteille sous atmosphère protectrice',
                            bg: 'Бутирано в защитна атмосфера', // Bulgaro
                            cs: 'Balený v ochranné atmosféře', // Ceco
                            hr: 'Bocačeno u zaštitnoj atmosferi', // Croato
                            da: 'Aftappet under beskyttende atmosfære', // Danese
                            et: 'Topsitud kaitseõhus', // Estone
                            fi: 'Pullotettu suojatussa ilmassa', // Finlandese
                            el: 'Μπουκαλισμένο σε προστατευτική ατμόσφαιρα', // Greco
                            ga: 'Buadáiste i dtimpeallacht chosanta', // Irlandese
                            lv: 'Ibutēts aizsardzības atmosfērā', // Lettone
                            lt: 'Buteliuose apsaugotoje atmosferoje', // Lituano
                            mt: 'Butirjat f’atmosfera protettiva', // Maltese
                            nl: 'Gebotteld in een beschermende atmosfeer', // Neerlandese
                            pl: 'Butelkowane w ochronnej atmosferze', // Polacco
                            pt: 'Engarrafado em atmosfera protetora', // Portoghese
                            ro: 'Îmbuteliat într-o atmosferă protectoare', // Rumeno
                            sk: 'Balené v ochrannej atmosfére', // Slovacco
                            sl: 'Bokt privožena v zaščitnem ozračju', // Sloveno
                            es: 'Envasado en atmósfera protectora', // Spagnolo
                            sv: 'Buteljerad i skyddande atmosfär', // Svedese
                            hu: 'Védő légkörben palackozva' // Ungherese
                        },
                    },
                    additivi: {
                        label: {
                            it: 'Additivi',
                            en: 'Additives',
                            de: 'Additive',
                            fr: 'Additifs',
                            bg: 'АДДИТИВИ', // Bulgaro
                            cs: 'ADITIVA', // Ceco
                            hr: 'Aditivi', // Croato
                            da: 'Tilsætningsstoffer', // Danese
                            et: 'Additiivid', // Estone
                            fi: 'Lisäaineet', // Finlandese
                            el: 'ΠΡΟΣΘΗΚΤΑ', // Greco
                            ga: 'Brucáilte', // Irlandese
                            lv: 'Pievienotie līdzekļi', // Lettone
                            lt: 'Pridėtinės medžiagos', // Lituano
                            mt: 'Addittivi', // Maltese
                            nl: 'Additieven', // Neerlandese
                            pl: 'Dodatki', // Polacco
                            pt: 'Aditivos', // Portoghese
                            ro: 'Aditivi', // Rumeno
                            sk: 'Aditívy', // Slovacco
                            sl: 'Aditivi', // Sloveno
                            es: 'Aditivos', // Spagnolo
                            sv: 'Tillsatser', // Svedese
                            hu: 'Adalékanyagok' // Ungherese
                        },
                    },
                    anidride: {
                        label: {
                            it: "anidride solforosa",
                            en: "sulfur dioxide",
                            de: 'Schwefeldioxid',
                            fr: 'Anhydride sulfureux',
                            bg: 'СУЛФУРНИ ДИОКСИД', // Bulgaro
                            cs: 'SIROVÝ DĚTROXID', // Ceco
                            hr: 'Sumporni dioksid', // Croato
                            da: 'Svoveldioksid', // Danese
                            et: 'Vääveldioksiid', // Estone
                            fi: 'Rikkidioksidi', // Finlandese
                            el: 'ΔΙΑΣΟΦΙΡΙΚΟ ΔΙΑΞΙΔΙΟ', // Greco
                            ga: 'Díoxéid sulphur', // Irlandese
                            lv: 'Sēra dioksīds', // Lettone
                            lt: 'Sieros dioksidas', // Lituano
                            mt: 'Djoċċīd s-sulfur', // Maltese
                            nl: 'Zwaveldioxide', // Neerlandese
                            pl: 'DWUMINÓG SIARKOWY', // Polacco
                            pt: 'DIOXIDO DE ENXOFRE', // Portoghese
                            ro: 'DIORGIN SULFUROZ', // Rumeno
                            sk: 'SIROVÝ DIOXID', // Slovacco
                            sl: 'Sumporni dioksid', // Sloveno
                            es: 'Dióxido de azufre', // Spagnolo
                            sv: 'Svaveldioxid', // Svedese
                            hu: 'Kén-dioxid' // Ungherese
                        }
                    },
                    bisolfito: {
                        label: {
                            it: "bisolfito di potassio",
                            en: "potassium bisulfite",
                            de: 'Kaliumbisulfit',
                            fr: 'Bisulfite de potassium',
                            bg: 'Калиев бисулфит', // Bulgaro
                            cs: 'POTASOVÝ BISULFIT', // Ceco
                            hr: 'Kalijev bisulfit', // Croato
                            da: 'Kaliumbisulfit', // Danese
                            et: 'Kaaliumvesiniksulfit', // Estone
                            fi: 'Kaliumbisulfiitti', // Finlandese
                            el: 'ΒΥΣΙΛΦΙΤΙΟ ΚΑΛΙΟΥ', // Greco
                            ga: 'Bisulfíte Potaisaim', // Irlandese
                            lv: 'Kālija bisulfitu', // Lettone
                            lt: 'Kalio bisulfitas', // Lituano
                            mt: 'Bisulfitu tal-Potassju', // Maltese
                            nl: 'Kaliumbisulfit', // Neerlandese
                            pl: 'BISULFIT POTASOWY', // Polacco
                            pt: 'BISULFITO DE POTÁSSIO', // Portoghese
                            ro: 'BISULFIT DE POTASIU', // Rumeno
                            sk: 'POTASOVÝ BISULFIT', // Slovacco
                            sl: 'Kalijev bisulfit', // Sloveno
                            es: 'Bisulfito de potasio', // Spagnolo
                            sv: 'Kaliumbisulfit', // Svedese
                            hu: 'Káliumbiszulfit' // Ungherese
                        }
                    },
                    metabisolfito: {
                        label: {
                            it: "metabisolfito di potassio",
                            en: "potassium metabisulfite",
                            de: 'Kaliummetabisulfit',
                            fr: 'Métabisulfite de potassium',
                            bg: 'КАЛИЙ МЕТАБИСУЛФИТ', // Bulgaro
                            cs: 'POTASOVÝ METABISULFIT', // Ceco
                            hr: 'Kalijev metabisulfit', // Croato
                            da: 'Kaliummetabisulfit', // Danese
                            et: 'Kaltsiummetabisulfaat', // Estone
                            fi: 'Kaliummetabisulfiitti', // Finlandese
                            el: 'ΒΥΣΙΛΦΙΤΙΟ ΜΕΤΑΚΑΛΙΟΥ', // Greco
                            ga: 'Metabisulfíte Potaisaim', // Irlandese
                            lv: 'Kālija metabisulfitu', // Lettone
                            lt: 'Kalio metabisulfitas', // Lituano
                            mt: 'Metabisulfitu tal-Potassju', // Maltese
                            nl: 'Kaliummetabisulfit', // Neerlandese
                            pl: 'METABISULFIT POTASOWY', // Polacco
                            pt: 'METABISULFITO DE POTÁSSIO', // Portoghese
                            ro: 'METABISULFIT DE POTASIU', // Rumeno
                            sk: 'POTASOVÝ METABISULFIT', // Slovacco
                            sl: 'Kalijev metabisulfit', // Sloveno
                            es: 'Metabisulfito de potasio', // Spagnolo
                            sv: 'Kaliummetabisulfit', // Svedese
                            hu: 'Káliummetabiszulfit' // Ungherese
                        }
                    },
                    sorbato: {
                        label: {
                            it: "sorbato di potassio",
                            en: "potassium sorbate",
                            de: 'Kaliumsorbat',
                            fr: 'Sorbate de potassium',
                            bg: 'ПOTASSIUM SORBATE', // Bulgaro
                            cs: 'POTASOVÝ SORBÁT', // Ceco
                            hr: 'Potasija sorbat', // Croato
                            da: 'Kaliumsorbat', // Danese
                            et: 'Kaltsiumsorbaat', // Estone
                            fi: 'Kaliumsorbaatti', // Finlandese
                            el: 'ΣΟΡΒΑΤΙΟ ΝΑΤΡΙΟΥ', // Greco
                            ga: 'Sorbáte Potaisaim', // Irlandese
                            lv: 'Kālija sorbāts', // Lettone
                            lt: 'Kalio sorbitas', // Lituano
                            mt: 'Sorbata tal-Potassju', // Maltese
                            nl: 'Kaliumsorbaat', // Neerlandese
                            pl: 'SORBIT POTASOWY', // Polacco
                            pt: 'SORBATO DE POTÁSSIO', // Portoghese
                            ro: 'SORBAT DE POTASIU', // Rumeno
                            sk: 'POTASOVÝ SORBÁT', // Slovacco
                            sl: 'Kalijev sorbat', // Sloveno
                            es: 'Sorbato de potasio', // Spagnolo
                            sv: 'Kaliumsorbat', // Svedese
                            hu: 'Káliumszorbát' // Ungherese
                        }
                    },
                    'l-ascorbico': {
                        label: {
                            it: "acido L-ascorbico",
                            en: "L-ascorbic acid",
                            de: 'Ascorbinsäure',
                            fr: 'Acide L-ascorbique',
                            bg: 'L-ASKORBINSКА КИСЕЛИНА', // Bulgaro
                            cs: 'L-ASKORBOVÁ KYSELINA', // Ceco
                            hr: 'L-askorbinska kiselina', // Croato
                            da: 'L-ascorbinsyre', // Danese
                            et: 'L-askorbiinhape', // Estone
                            fi: 'L-asetyylihappo', // Finlandese
                            el: 'ΟΞΙΚΗ ΟΞΕΣΗ L-ΑΣΚΟΡΒΙΚΗ', // Greco
                            ga: 'Acidh L-Ascórbic', // Irlandese
                            lv: 'L-askorbīnskābe', // Lettone
                            lt: 'L-askorbo rūgštis', // Lituano
                            mt: 'Acidu L-askorbiku', // Maltese
                            nl: 'L-ascorbinezuur', // Neerlandese
                            pl: 'KWAS ASKORBIKOWY', // Polacco
                            pt: 'ÁCIDO L-ASCÓRBICO', // Portoghese
                            ro: 'ACID L-ASKORBIC', // Rumeno
                            sk: 'L-ASKORBOVÁ KYSELINA', // Slovacco
                            sl: 'L-askorbinska kislina', // Sloveno
                            es: 'Ácido L-ascórbico', // Spagnolo
                            sv: 'L-askorbinsyra', // Svedese
                            hu: 'L-askorbinsav' // Ungherese
                        }
                    },
                    dmdc: {
                        label: {
                            it: "Dimetilcarbonato (DMDC)",
                            en: "Dimethyl carbonate (DMDC)",
                            de: 'Dimethylcarbonat (DMDC)',
                            fr: 'Carbonate de diméthyle (DMDC)',
                            bg: 'ДИМЕТИЛКАРБОНАТ (DMDC)', // Bulgaro
                            cs: 'Dimethylkarbonát (DMDC)', // Ceco
                            hr: 'Dimetilkarbonat (DMDC)', // Croato
                            da: 'Dimethyldicarbonat (DMDC)', // Danese
                            et: 'Dimetüüülkarbonaat (DMDC)', // Estone
                            fi: 'Dimetyylikarbonaatti (DMDC)', // Finlandese
                            el: 'ΔΙΜΕΘΥΛΚΑΡΒΟΝΑΤΟ (DMDC)', // Greco
                            ga: 'Diméthilcarbonat (DMDC)', // Irlandese
                            lv: 'Dimetilkarbonskābe (DMDC)', // Lettone
                            lt: 'Dimetilkarbonatas (DMDC)', // Lituano
                            mt: 'Dimetilkarbonat (DMDC)', // Maltese
                            nl: 'Dimethylcarbonaat (DMDC)', // Neerlandese
                            pl: 'Dimetylokarbonat (DMDC)', // Polacco
                            pt: 'Carbonato de dimetila (DMDC)', // Portoghese
                            ro: 'Carbonat de dimetilă (DMDC)', // Rumeno
                            sk: 'Dimetylkarbonát (DMDC)', // Slovacco
                            sl: 'Dimetilkarbonat (DMDC)', // Sloveno
                            es: 'Carbonato de dimetilo (DMDC)', // Spagnolo
                            sv: 'Dimetylkarbonat (DMDC)', // Svedese
                            hu: 'Dimetil-karbonát (DMDC)' // Ungherese
                        }
                    },
                    resina: {
                        label: {
                            it: "resina di pino di Aleppo",
                            en: "Aleppo pine resin",
                            de: 'Aleppokiefernharz',
                            fr: 'Résine de pin d\'Alep',
                            bg: 'РЕСИНА ОТ ПИНАТА АЛЕП', // Bulgaro
                            cs: 'Resina Aleppské pini', // Ceco
                            hr: 'Aleppova smola bora', // Croato
                            da: 'Aleppofyrharpiks', // Danese
                            et: 'Aleppo männi resiin', // Estone
                            fi: 'Aleppon mäntymuovi', // Finlandese
                            el: 'ΡΕΖΙΝΗ ΠΙΝΑ ΑΛΕΠΠΟ', // Greco
                            ga: 'Resín fi pi Aleppo', // Irlandese
                            lv: 'Aleppas egles sapnis', // Lettone
                            lt: 'Aleppo pušies rezina', // Lituano
                            mt: 'Rumina tal-Pinu ta\' Aleppo', // Maltese
                            nl: 'Aleppopijnboomhars', // Neerlandese
                            pl: 'Żywica sosny aleppo', // Polacco
                            pt: 'Resina de pinho de Aleppo', // Portoghese
                            ro: 'Rășină de pin Aleppo', // Rumeno
                            sk: 'Rezina Aleppského borovice', // Slovacco
                            sl: 'Aleppo smola borovnice', // Sloveno
                            es: 'Resina de pino de Alepo', // Spagnolo
                            sv: 'Aleppopinsresin', // Svedese
                            hu: 'Aleppói fenyőgyanta' // Ungherese
                        }
                    },
                    caramello: {
                        label: {
                            it: "Caramello",
                            en: "Caramel",
                            de: 'Karamell',
                            fr: 'Caramel',
                            bg: 'КАРАМЕЛ', // Bulgaro
                            cs: 'KARAMEL', // Ceco
                            hr: 'Karamela', // Croato
                            da: 'Karamel', // Danese
                            et: 'Karamell', // Estone
                            fi: 'Karamelli', // Finlandese
                            el: 'ΚΑΡΑΜΕΛ', // Greco
                            ga: 'Caraiméar', // Irlandese
                            lv: 'Karamelis', // Lettone
                            lt: 'Karamelė', // Lituano
                            mt: 'Karavella', // Maltese
                            nl: 'Karamel', // Neerlandese
                            pl: 'Karmel', // Polacco
                            pt: 'Caramelo', // Portoghese
                            ro: 'Caramel', // Rumeno
                            sk: 'Karamel', // Slovacco
                            sl: 'Karamel', // Sloveno
                            es: 'Caramelo', // Spagnolo
                            sv: 'Karamell', // Svedese
                            hu: 'Karamell' // Ungherese
                        }
                    },
                    coadiuvanti: {
                        label: {
                            it: "Coadiuvanti tecnologici",
                            en: "Technological aids",
                            de: 'Technologische Hilfsmittel',
                            fr: 'Aides technologiques',
                            bg: 'ТЕХНОЛОГИЧЕСКИ ПОМОЩНИ СРЕДСТВА', // Bulgaro
                            cs: 'Technologické pomocné prostředky', // Ceco
                            hr: 'Tehnološka pomoćna sredstva', // Croato
                            da: 'Teknologiske hjælpemidler', // Danese
                            et: 'Tehnoloogilised abivahendid', // Estone
                            fi: 'Teknologiset avustimet', // Finlandese
                            el: 'ΤΕΧΝΟΛΟΓΙΚΑ ΒΟΗΘΗΤΙΚΑ', // Greco
                            ga: 'Cabhair theicneolaíochta', // Irlandese
                            lv: 'Tehnoloģiskie palīgmateriāli', // Lettone
                            lt: 'Technologiniai pagalbiniai įrankiai', // Lituano
                            mt: 'Aġġenti Tekniċi', // Maltese
                            nl: 'Technologische hulpmiddelen', // Neerlandese
                            pl: 'Pomoc techniczna', // Polacco
                            pt: 'Ajudas tecnológicas', // Portoghese
                            ro: 'Ajutoare tehnologice', // Rumeno
                            sk: 'Technologické pomocné prostriedky', // Slovacco
                            sl: 'Tehnološka pomožna sredstva', // Sloveno
                            es: 'Ayudas tecnológicas', // Spagnolo
                            sv: 'Teknologiska hjälpmedel', // Svedese
                            hu: 'Technológiai segédeszközök' // Ungherese
                        }
                    },
                    solfiti: {
                        label: {
                            it: "solfiti o anidride solforosa",
                            en: "sulphites or sulfur dioxide",
                            de: 'Sulfite oder Schwefeldioxid',
                            fr: 'Sulfites ou anhydride sulfureux',
                            bg: 'СУЛФИТИ ИЛИ СУЛФУРНИ ДИОКСИД', // Bulgaro
                            cs: 'Sulfity nebo oxid siřičitý', // Ceco
                            hr: 'Sulfiti ili sumporni dioksid', // Croato
                            da: 'Sulfitter eller svoveldioksid', // Danese
                            et: 'Sülfiidid või vääveldioksiid', // Estone
                            fi: 'Sulfiti tai rikkidioksidi', // Finlandese
                            el: 'Θειώδεις ή διοξείδιο του θείου', // Greco
                            ga: 'Sulfáid nó dióxid siadmhéarla', // Irlandese
                            lv: 'Sulfīti vai sēra dioksīds', // Lettone
                            lt: 'Sulfitai arba sieros dioksidas', // Lituano
                            mt: 'Sulfiti jew dioksidu tas-sulfur', // Maltese
                            nl: 'Sulfieten of zwaveldioxide', // Neerlandese
                            pl: 'SIÓLWA LUB DWUMINÓG SIARKOWY', // Polacco
                            pt: 'SULFITOS OU DIÓXIDO DE ENXOFRE', // Portoghese
                            ro: 'Sulfiti sau dioxid de sulf', // Rumeno
                            sk: 'Sulfity alebo oxid siričitý', // Slovacco
                            sl: 'Sulfiti ali žveplov dioksid', // Sloveno
                            es: 'Sulfitos o dióxido de azufre', // Spagnolo
                            sv: 'Sulfiter eller svaveldioxid', // Svedese
                            hu: 'Szulfátok vagy kén-dioxid' // Ungherese
                        }
                    },
                    uovo: {
                        label: {
                            it: "uovo",
                            en: "egg",
                            de: 'Ei',
                            fr: 'Œuf',
                            bg: 'ЯЙЦЕ', // Bulgaro
                            cs: 'Vejce', // Ceco
                            hr: 'Jaje', // Croato
                            da: 'Æg', // Danese
                            et: 'Muna', // Estone
                            fi: 'Muna', // Finlandese
                            el: 'ΑΥΓΟ', // Greco
                            ga: 'Oinbhí', // Irlandese
                            lv: 'Ola', // Lettone
                            lt: 'Kiaušinis', // Lituano
                            mt: 'Bejgħa', // Maltese
                            nl: 'Ei', // Neerlandese
                            pl: 'Jajo', // Polacco
                            pt: 'Ovo', // Portoghese
                            ro: 'Ou', // Rumeno
                            sk: 'Vajce', // Slovacco
                            sl: 'Jajce', // Sloveno
                            es: 'Huevo', // Spagnolo
                            sv: 'Ägg', // Svedese
                            hu: 'Tojás' // Ungherese
                        }
                    },
                    proteina: {
                        label: {
                            it: "proteina dell’uovo",
                            en: "egg protein",
                            de: 'Eiprotein',
                            fr: 'Protéine d\'œuf',
                            bg: 'БЕЛТЕИН ОТ ЯЙЦЕ', // Bulgaro
                            cs: 'Vaječný protein', // Ceco
                            hr: 'Proteini od jaja', // Croato
                            da: 'Æggehvideprotein', // Danese
                            et: 'Muna valk', // Estone
                            fi: 'Munaproteiini', // Finlandese
                            el: 'ΠΡΩΤΕΊΝΗ ΑΥΓΟΥ', // Greco
                            ga: 'Prótín bhí óin', // Irlandese
                            lv: 'Olu proteīns', // Lettone
                            lt: 'Kiaušinio baltymas', // Lituano
                            mt: 'Proteina tal-bejgħa', // Maltese
                            nl: 'Ei-eiwit', // Neerlandese
                            pl: 'PROTEINA JAJEL', // Polacco
                            pt: 'Proteína de ovo', // Portoghese
                            ro: 'Proteină de ou', // Rumeno
                            sk: 'Vaječný proteín', // Slovacco
                            sl: 'Beljakovine jajca', // Sloveno
                            es: 'Proteína de huevo', // Spagnolo
                            sv: 'Äggprotein', // Svedese
                            hu: 'Tojásfehérje' // Ungherese
                        }
                    },
                    'derivati-uovo': {
                        label: {
                            it: "derivati dell’uovo",
                            en: "egg derivatives",
                            de: 'Ei-Derivate',
                            fr: 'Dérivés d\'œuf',
                            bg: 'ПРЕДИРОДНИ ПРОДУКТИ ОТ ЯЙЦЕ', // Bulgaro
                            cs: 'Odvozy z vejce', // Ceco
                            hr: 'Derivati od jaja', // Croato
                            da: 'Ægderivater', // Danese
                            et: 'Muna tuletised', // Estone
                            fi: 'Munasirkotuotteet', // Finlandese
                            el: 'ΓΕΝΙΚΑ ΠΡΟΪΟΝΤΑ ΑΥΓΟΥ', // Greco
                            ga: 'Haidreidhne i dteaghlach bhí óin', // Irlandese
                            lv: 'Ola atvasinājumi', // Lettone
                            lt: 'Kiaušinio gaminiai', // Lituano
                            mt: 'Derivati tal-bejgħa', // Maltese
                            nl: 'Ei-derivaten', // Neerlandese
                            pl: 'POCHODNE PRODUKTY Z JAJKA', // Polacco
                            pt: 'Derivados do ovo', // Portoghese
                            ro: 'Derivate din ou', // Rumeno
                            sk: 'Vaječné deriváty', // Slovacco
                            sl: 'Jajčna derivacija', // Sloveno
                            es: 'Derivados del huevo', // Spagnolo
                            sv: 'Äggderivat', // Svedese
                            hu: 'Tojás származékai' // Ungherese
                        }
                    },
                    ovoalbumina: {
                        label: {
                            it: "lisozima da uovo o ovoalbumina",
                            en: "lysozyme from egg or egg albumin",
                            de: 'Ei-Lysozym oder Ovalbumin',
                            fr: 'Lysozyme ou albumine d\'œuf',
                            bg: 'ЛИЗОЗИМ ОТ ЯЙЦЕ ИЛИ ОВОАЛБУМИН', // Bulgaro
                            cs: 'Lysozym z vejce nebo ovalbumin', // Ceco
                            hr: 'Lisozima iz jaja ili ovalbumin', // Croato
                            da: 'Lysozym fra æg eller ovalbumin', // Danese
                            et: 'Muna lisoosüüm või ovalbumiin', // Estone
                            fi: 'Avastejuuri munasta tai ovalbumiini', // Finlandese
                            el: 'ΛΥΣΟΖΊΜΗ ΑΥΓΟΥ Ή ΟΥΑΛΜΠΟΥΜΙΝΗ', // Greco
                            ga: 'Lysozym óin nó albumin óin', // Irlandese
                            lv: 'Lizozeīns no olu vai olovalmīns', // Lettone
                            lt: 'Lizozimas iš kiaušinio arba ovalbuminas', // Lituano
                            mt: 'Lizozim mill-bejgħa jew albumin tal-bejgħa', // Maltese
                            nl: 'Lysosyme van ei of ovalbumine', // Neerlandese
                            pl: 'Lizozym z jajka lub ovalbumina', // Polacco
                            pt: 'Lisozima do ovo ou albumina do ovo', // Portoghese
                            ro: 'Lizozim din ou sau albumină de ou', // Rumeno
                            sk: 'Lysozym z vajca alebo ovalbumín', // Slovacco
                            sl: 'Lizozim iz jajca ali ovalbumin', // Sloveno
                            es: 'Lisozima de huevo o albúmina de huevo', // Spagnolo
                            sv: 'Lysozym från ägg eller ovalbumin', // Svedese
                            hu: 'Tojás-lyzozím vagy ovalbumin' // Ungherese
                        }
                    },
                    latte: {
                        label: {
                            it: "latte",
                            en: "milk",
                            de: 'Milch',
                            fr: 'Lait',
                            bg: 'МЛЕКО', // Bulgaro
                            cs: 'Mléko', // Ceco
                            hr: 'Mlijeko', // Croato
                            da: 'Mælk', // Danese
                            et: 'Piim', // Estone
                            fi: 'Maito', // Finlandese
                            el: 'ΓΑΛΑ', // Greco
                            ga: 'Bainne', // Irlandese
                            lv: 'Piens', // Lettone
                            lt: 'Pienas', // Lituano
                            mt: 'Ħalib', // Maltese
                            nl: 'Melk', // Neerlandese
                            pl: 'Mleko', // Polacco
                            pt: 'Leite', // Portoghese
                            ro: 'Lapte', // Rumeno
                            sk: 'Mlieko', // Slovacco
                            sl: 'Mleko', // Sloveno
                            es: 'Leche', // Spagnolo
                            sv: 'Mjölk', // Svedese
                            hu: 'Tej' // Ungherese
                        }
                    },
                    'derivati-latte': {
                        label: {
                            it: "derivati del latte",
                            en: "milk derivatives",
                            de: 'Milchderivate',
                            fr: 'Dérivés du lait',
                            bg: 'ПРЕДИРОДНИ ПРОДУКТИ ОТ МЛЕКО', // Bulgaro
                            cs: 'Mlékové deriváty', // Ceco
                            hr: 'Derivati od mlijeka', // Croato
                            da: 'Mælkeprodukter', // Danese
                            et: 'Piimatooted', // Estone
                            fi: 'Maitotuotteet', // Finlandese
                            el: 'ΔΗΜΙΟΥΓΝΕΣ ΓΑΛΑΚΤΟΣ', // Greco
                            ga: 'Deriváid bainne', // Irlandese
                            lv: 'Piens atvasinājumi', // Lettone
                            lt: 'Pieno gaminiai', // Lituano
                            mt: 'Derivati tal-ħalib', // Maltese
                            nl: 'Melkderivaten', // Neerlandese
                            pl: 'Pochodne mleka', // Polacco
                            pt: 'Derivados do leite', // Portoghese
                            ro: 'Derivate din lapte', // Rumeno
                            sk: 'Mliečne deriváty', // Slovacco
                            sl: 'Mlečni derivati', // Sloveno
                            es: 'Derivados de la leche', // Spagnolo
                            sv: 'Mjölkderivat', // Svedese
                            hu: 'Tej származékok' // Ungherese
                        }
                    },
                    'caseina-latte': {
                        label: {
                            it: "caseina del latte o proteina del latte",
                            en: "milk casein or milk protein",
                            de: 'Milchcasein oder Milchprotein',
                            fr: 'Caséine ou protéine du lait',
                            bg: 'КАЗЕИН ОТ МЛЕКО ИЛИ МЛЕЧЕН БЕЛТЕИН', // Bulgaro
                            cs: 'Kasein z mléka nebo mléčný protein', // Ceco
                            hr: 'Casein mlijeka ili mliječni protein', // Croato
                            da: 'Mælkekasein eller mælkeprotein', // Danese
                            et: 'Piima kaseiin või piimavalgu', // Estone
                            fi: 'Maito kaseiini tai maidon proteiini', // Finlandese
                            el: 'ΚΑΖΕΪΝΗ ΓΑΛΑΚΤΟΣ Ή ΤΟ ΓΑΛΑΚΤΙΚΟ ΠΡΩΤΕΊΝΟ', // Greco
                            ga: 'Caseín bainne nó prótín bainne', // Irlandese
                            lv: 'Piens kaseīns vai piens proteīns', // Lettone
                            lt: 'Pienos kaseinas arba pieno baltymas', // Lituano
                            mt: 'Caseina tal-ħalib jew proteina tal-ħalib', // Maltese
                            nl: 'Melkcaseïne of melkproteïne', // Neerlandese
                            pl: 'Kazeina mleczna lub białko mleczne', // Polacco
                            pt: 'Caseína do leite ou proteína do leite', // Portoghese
                            ro: 'Cazeină din lapte sau proteină din lapte', // Rumeno
                            sk: 'Mliečny kaseín alebo mliečny proteín', // Slovacco
                            sl: 'Mlečni kazein ali mlečni protein', // Sloveno
                            es: 'Caseína de leche o proteína de leche', // Spagnolo
                            sv: 'Mjölk kasein eller mjölkprotein', // Svedese
                            hu: 'Tejkazein vagy tejfehérje' // Ungherese
                        }
                    },
                    regolatori_acidita: {
                        label: {
                            it: "Regolatori dell’acidità e agenti stabilizzanti",
                            en: "Acidity regulators and stabilizing agents",
                            de: 'Säureregulatoren und Stabilisierungsmittel',
                            fr: 'Régulateurs d\'acidité et agents stabilisants',
                            bg: 'РЕГУЛАТОРИ НА КИСЕЛИННОСТТА И СТАБИЛИЗАТОРНИ СРЕДСТВА', // Bulgaro
                            cs: 'Regulátory kyselosti a stabilizační látky', // Ceco
                            hr: 'Regulatori kiselosti i stabilizatori', // Croato
                            da: 'Surhedsregulerende midler og stabilisatorer', // Danese
                            et: 'Hapuseadmete regulaatorid ja stabiliseerivad ained', // Estone
                            fi: 'Happamuuden säätelijät ja stabilointiaineet', // Finlandese
                            el: 'ΡΥΘΜΙΣΤΕΣ ΟΞΕΥΣΗΣ ΚΑΙ ΣΤΑΒΙΛΟΖΟΝΤΑ ΣΥΜΒΑΤΑ', // Greco
                            ga: 'Roghaltóirí acidic agus gníomhairí stábailithe', // Irlandese
                            lv: 'Skābums regulatori un stabilizatori', // Lettone
                            lt: 'Rūgštingumo reguliatoriai ir stabilizatoriai', // Lituano
                            mt: 'Regolaturi tal-asidità u aġenti stabilizzanti', // Maltese
                            nl: 'Zuurregelaars en stabilisatoren', // Neerlandese
                            pl: 'Regulatory kwasowości i środki stabilizujące', // Polacco
                            pt: 'Reguladores de acidez e agentes estabilizantes', // Portoghese
                            ro: 'Regulatori de aciditate și agenți de stabilizare', // Rumeno
                            sk: 'Regulátory kyslosti a stabilizačné látky', // Slovacco
                            sl: 'Regulatorji kislosti in stabilizatorji', // Sloveno
                            es: 'Reguladores de acidez y agentes estabilizantes', // Spagnolo
                            sv: 'Syraregulatorer och stabiliserande ämnen', // Svedese
                            hu: 'Savasság szabályozók és stabilizáló anyagok' // Ungherese
                        }
                    },
                    "tartarico": {
                        label: {
                            it: "acido tartarico",
                            en: "tartaric acid",
                            de: "Weinsäure",
                            fr: 'Acide tartrique',
                            bg: 'МАЛЕСКА КИСЕЛИНА', // Bulgaro
                            cs: 'Kyselina vinná', // Ceco
                            hr: 'Tartarna kiselina', // Croato
                            da: 'Vinsyre', // Danese
                            et: 'Tartarhape', // Estone
                            fi: 'Tartarihappo', // Finlandese
                            el: 'ΤΑΡΤΑΡΙΚΟ ΟΞΕΣ', // Greco
                            ga: 'Acid tartrach', // Irlandese
                            lv: 'Tartriskābe', // Lettone
                            lt: 'Tartarų rūgštis', // Lituano
                            mt: 'Acidu tartarik', // Maltese
                            nl: 'Tartarzuur', // Neerlandese
                            pl: 'KWAS TARTAROWY', // Polacco
                            pt: 'Ácido tartárico', // Portoghese
                            ro: 'Acid tartaric', // Rumeno
                            sk: 'Tartariová kyselina', // Slovacco
                            sl: 'Tartarna kislina', // Sloveno
                            es: 'Ácido tartárico', // Spagnolo
                            sv: 'Vintersyra', // Svedese
                            hu: 'Tartarinsav' // Ungherese
                        }
                    },
                    "malico": {
                        label: {
                            it: "acido malico",
                            en: "malic acid",
                            de: "Äpfelsäure",
                            fr: 'Acide malique',
                            bg: 'JABЪLKОВА КИСЕЛИНА', // Bulgaro
                            cs: 'Jablečná kyselina', // Ceco
                            hr: 'Malinska kiselina', // Croato
                            da: 'Æblesyre', // Danese
                            et: 'Malikhape', // Estone
                            fi: 'Omenahappo', // Finlandese
                            el: 'ΜΑΛΙΚΗ ΟΞΕΣΗ', // Greco
                            ga: 'Acid máilc', // Irlandese
                            lv: 'Maliskābe', // Lettone
                            lt: 'Obes rūgštis', // Lituano
                            mt: 'Acidu malik', // Maltese
                            nl: 'Appelzuur', // Neerlandese
                            pl: 'KWAS JABŁKOWY', // Polacco
                            pt: 'Ácido málico', // Portoghese
                            ro: 'Acid mǎlic', // Rumeno
                            sk: 'Jablčná kyselina', // Slovacco
                            sl: 'Jabolčna kislina', // Sloveno
                            es: 'Ácido málico', // Spagnolo
                            sv: 'Äppelsyra', // Svedese
                            hu: 'Almapolsav' // Ungherese
                        }
                    },
                    "lattico": {
                        label: {
                            it: "acido lattico",
                            en: "lactic acid",
                            de: "Milchsäure",
                            fr: 'Acide lactique',
                            bg: 'МЛЕЧНА КИСЕЛИНА', // Bulgaro
                            cs: 'Mléčná kyselina', // Ceco
                            hr: 'Mlinska kiselina', // Croato
                            da: 'Mælkesyre', // Danese
                            et: 'Piimhape', // Estone
                            fi: 'Maitohappo', // Finlandese
                            el: 'ΓΑΛΑΚΤΙΚΗ ΟΞΕΣΗ', // Greco
                            ga: 'Acid láctach', // Irlandese
                            lv: 'Pienskābe', // Lettone
                            lt: 'Pieno rūgštis', // Lituano
                            mt: 'Acidu laktiku', // Maltese
                            nl: 'Melkzuur', // Neerlandese
                            pl: 'KWAS MLECZNY', // Polacco
                            pt: 'Ácido lático', // Portoghese
                            ro: 'Acid lactic', // Rumeno
                            sk: 'Mliečna kyselina', // Slovacco
                            sl: 'Mlečna kislina', // Sloveno
                            es: 'Ácido láctico', // Spagnolo
                            sv: 'Mjölksyra', // Svedese
                            hu: 'Tejsav' // Ungherese
                        }
                    },
                    "solfato-calcio": {
                        label: {
                            it: "solfato di calcio",
                            en: "calcium sulfate",
                            de: "Calciumsulfat",
                            fr: 'Sulfate de calcium',
                            bg: 'КАЛЦИЕВ СУЛФАТ', // Bulgaro
                            cs: 'Síran vápenatý', // Ceco
                            hr: 'Kalcijev sulfat', // Croato
                            da: 'Calciumsulfat', // Danese
                            et: 'Kaltsiumsülfaat', // Estone
                            fi: 'Kalsiumsulfaatti', // Finlandese
                            el: 'ΓΑΛΣΙΟΥ ΣΥΛΦΑΤΙΟ', // Greco
                            ga: 'Sulfát caláide', // Irlandese
                            lv: 'Kalcija sulfāts', // Lettone
                            lt: 'Kalcio sulfatas', // Lituano
                            mt: 'Sulfat tal-Kalkju', // Maltese
                            nl: 'Calciumsulfaat', // Neerlandese
                            pl: 'SIÓRAN WAPNIANY', // Polacco
                            pt: 'Sulfato de cálcio', // Portoghese
                            ro: 'Sulfat de calciu', // Rumeno
                            sk: 'Vápnik síran', // Slovacco
                            sl: 'Kalcijev sulfat', // Sloveno
                            es: 'Sulfato de calcio', // Spagnolo
                            sv: 'Kalciumsulfat', // Svedese
                            hu: 'Kalciumszulfát' // Ungherese
                        }
                    },
                    "citrico": {
                        label: {
                            it: "acido citrico",
                            en: "citric acid",
                            de: "Zitronensäure",
                            fr: 'Acide citrique',
                            bg: 'ЦИТРИЧНА КИСЕЛИНА', // Bulgaro
                            cs: 'Kyselina citronová', // Ceco
                            hr: 'Limejska kiselina', // Croato
                            da: 'Citronsyre', // Danese
                            et: 'Tsitrushape', // Estone
                            fi: 'Sitruunahappo', // Finlandese
                            el: 'ΛΕΜΟΝΙΚΗ ΟΞΕΣΗ', // Greco
                            ga: 'Acid citreach', // Irlandese
                            lv: 'Citronskābe', // Lettone
                            lt: 'Citrininė rūgštis', // Lituano
                            mt: 'Acidu ċitruċiku', // Maltese
                            nl: 'Citroenzuur', // Neerlandese
                            pl: 'KWAS CITRONOWY', // Polacco
                            pt: 'Ácido cítrico', // Portoghese
                            ro: 'Acid citric', // Rumeno
                            sk: 'Kyselina citrónová', // Slovacco
                            sl: 'Citronska kislina', // Sloveno
                            es: 'Ácido cítrico', // Spagnolo
                            sv: 'Citronsyra', // Svedese
                            hu: 'Citromsav' // Ungherese
                        }
                    },
                    "metatartarico": {
                        label: {
                            it: "acido metatartarico",
                            en: "metatartaric acid",
                            de: "Metaweinsäure",
                            fr: 'Acide métatartrique',
                            bg: 'МЕТАТАРТАРНА КИСЕЛИНА', // Bulgaro
                            cs: 'Metatartrická kyselina', // Ceco
                            hr: 'Metatartarna kiselina', // Croato
                            da: 'Meta-vinsyre', // Danese
                            et: 'Metatartriinhape', // Estone
                            fi: 'Metatartarihappo', // Finlandese
                            el: 'ΜΕΤΑΤΑΡΤΑΡΙΚΗ ΟΞΕΣΗ', // Greco
                            ga: 'Acid métatartrique', // Irlandese
                            lv: 'Metatartriskābe', // Lettone
                            lt: 'Metatartrik rūgštis', // Lituano
                            mt: 'Acidu metatartariku', // Maltese
                            nl: 'Metatartraatzuur', // Neerlandese
                            pl: 'KWAS METATARTRYNOWY', // Polacco
                            pt: 'Ácido metartarico', // Portoghese
                            ro: 'Acid metatartaric', // Rumeno
                            sk: 'Metatartrová kyselina', // Slovacco
                            sl: 'Metatartrična kislina', // Sloveno
                            es: 'Ácido metartarico', // Spagnolo
                            sv: 'Metartarinsyra', // Svedese
                            hu: 'Metatartrinsav' // Ungherese
                        }
                    },
                    "gomma-arabica": {
                        label: {
                            it: "gomma arabica",
                            en: "gum arabic",
                            de: "Arabischer Gummi",
                            fr: 'Gomme arabique',
                            bg: 'АРАБСКА ЖЕЛЕ', // Bulgaro
                            cs: 'Arabský guma', // Ceco
                            hr: 'Arapska guma', // Croato
                            da: 'Gummi arabicum', // Danese
                            et: 'Araabia kumm', // Estone
                            fi: 'Arabiankummi', // Finlandese
                            el: 'ΑΡΑΒΙΚΗ ΡΑΓΚΑ', // Greco
                            ga: 'Gumma Araimíoch', // Irlandese
                            lv: 'Arābu gume', // Lettone
                            lt: 'Arabikos guma', // Lituano
                            mt: 'Kummu Arabiku', // Maltese
                            nl: 'Arabische gom', // Neerlandese
                            pl: 'Guma arabska', // Polacco
                            pt: 'Goma arábica', // Portoghese
                            ro: 'Gumă arabică', // Rumeno
                            sk: 'Arabská guma', // Slovacco
                            sl: 'Arapska guma', // Sloveno
                            es: 'Goma arábica', // Spagnolo
                            sv: 'Arabisk gummi', // Svedese
                            hu: 'Arab gumi' // Ungherese
                        }
                    },
                    "lieviti": {
                        label: {
                            it: "mannoproteine di lieviti",
                            en: "yeast mannoproteins",
                            de: "Hefe-Mannoproteine",
                            fr: 'Mannoprotéines de levures',
                            bg: 'МАННОПРОТЕИНИ ОТ ДРЖЕВИ', // Bulgaro
                            cs: 'Mannoproteiny z kvasnic', // Ceco
                            hr: 'Mannoproteini kvasaca', // Croato
                            da: 'Mannoproteiner fra gær', // Danese
                            et: 'Pecede mannopeptiidid', // Estone
                            fi: 'Hiivan mannoproteiinit', // Finlandese
                            el: 'ΜΑΝΝΟΠΡΟΤΕΊΝΕΣ ΑΠΟ ΜΥΚΟΦΥΤΙΚΑ', // Greco
                            ga: 'Mannoproteínas milse', // Irlandese
                            lv: 'Manno proteīni no rauga', // Lettone
                            lt: 'Manno baltymai iš mielių', // Lituano
                            mt: 'Mannoproteini tal-mirħa', // Maltese
                            nl: 'Gist mannoproteïnen', // Neerlandese
                            pl: 'Mannoproteiny drożdżowe', // Polacco
                            pt: 'Mannoproteínas de levedura', // Portoghese
                            ro: 'Mannoproteine de drojdie', // Rumeno
                            sk: 'Hefové mannoproteíny', // Slovacco
                            sl: 'Kvasni mannoproteini', // Sloveno
                            es: 'Mannoproteínas de levadura', // Spagnolo
                            sv: 'Jäst mannoproteiner', // Svedese
                            hu: 'Élesztő mannoproteinek' // Ungherese
                        }
                    },
                    "carbossimetilcellulosa": {
                        label: {
                            it: "Carbossimetilcellulosa",
                            en: "carboxymethylcellulose",
                            de: "Carboxymethylcellulose",
                            fr: 'Carboxyméthylcellulose',
                            bg: 'КАРБОКСИСЕТИЛЦЕЛЮЛОЗА', // Bulgaro
                            cs: 'Carboxymethylcelulóza', // Ceco
                            hr: 'Karboximetilceluloza', // Croato
                            da: 'Carboxymethylcellulose', // Danese
                            et: 'Karboksümeetüültselluloos', // Estone
                            fi: 'Karboksimetyyliselluloosa', // Finlandese
                            el: 'ΚΑΡΒΟΞΥΜΕΘΥΛΚΕΛΟΥΛΩΖΑ', // Greco
                            ga: 'Carboxymethylcellulose', // Irlandese
                            lv: 'Karboksemētseluloze', // Lettone
                            lt: 'Karboximetilceliuliozas', // Lituano
                            mt: 'Karboxiimetilsejluloża', // Maltese
                            nl: 'Carboxymethylcellulose', // Neerlandese
                            pl: 'Carboxymetyloceluloza', // Polacco
                            pt: 'Carboximetilcelulose', // Portoghese
                            ro: 'Carboximetilceluloză', // Rumeno
                            sk: 'Karboxymetylcelulóza', // Slovacco
                            sl: 'Karboximetilceluloza', // Sloveno
                            es: 'Carboximetilcelulosa', // Spagnolo
                            sv: 'Karboxymetylcellulosa', // Svedese
                            hu: 'Karboximetil-cellulóz' // Ungherese
                        }
                    },
                    "poliaspartato": {
                        label: {
                            it: "Poliaspartato di potassio",
                            en: "potassium polyaspartate",
                            de: "Kaliumpolyaspartat",
                            fr: 'Polyaspartate de potassium',
                            bg: 'Калиев полиаспартат', // Bulgaro
                            cs: 'Kaliumpolyaspartát', // Ceco
                            hr: 'Potasij polyaspartat', // Croato
                            da: 'Kaliumpolyaspartat', // Danese
                            et: 'Kaliumpolyaspartaat', // Estone
                            fi: 'Kaliumpolyaspartaatti', // Finlandese
                            el: 'Πολυασπαρτικό κάλιο', // Greco
                            ga: 'Polyaspartáid Potaisaim', // Irlandese
                            lv: 'Kālija poliaspartāts', // Lettone
                            lt: 'Kalio poliaspartatas', // Lituano
                            mt: 'Polyaspartat tal-Potassju', // Maltese
                            nl: 'Kaliumpoly-aspartaat', // Neerlandese
                            pl: 'POLIASPARTAT POTASOWY', // Polacco
                            pt: 'Poliaspartato de potássio', // Portoghese
                            ro: 'Poliaspartat de potasiu', // Rumeno
                            sk: 'Kaliumpolyaspartát', // Slovacco
                            sl: 'Kalijev poliaspartat', // Sloveno
                            es: 'Poliaspartato de potasio', // Spagnolo
                            sv: 'Kaliumpolyaspartat', // Svedese
                            hu: 'Káliumpolyaspartát' // Ungherese
                        }
                    },
                    "fumarico": {
                        label: {
                            it: "Acido fumarico",
                            en: "fumaric acid",
                            de: "Fumarsäure",
                            fr: 'Acide fumarique',
                            bg: 'ФУМАРИНА КИСЕЛИНА', // Bulgaro
                            cs: 'Kyselina fumará', // Ceco
                            hr: 'Fumarska kiselina', // Croato
                            da: 'Fumarsyre', // Danese
                            et: 'Fumaarhape', // Estone
                            fi: 'Fumariinihappo', // Finlandese
                            el: 'ΦΟΥΜΑΡΙΚΗ ΟΞΕΣΗ', // Greco
                            ga: 'Acid fumarach', // Irlandese
                            lv: 'Fumārskābe', // Lettone
                            lt: 'Fumarų rūgštis', // Lituano
                            mt: 'Acidu fumarik', // Maltese
                            nl: 'Fumarsyrup', // Neerlandese
                            pl: 'KWAS FUMAROWY', // Polacco
                            pt: 'Ácido fumárico', // Portoghese
                            ro: 'Acid fumarian', // Rumeno
                            sk: 'Fumarová kyselina', // Slovacco
                            sl: 'Fumarska kislina', // Sloveno
                            es: 'Ácido fumárico', // Spagnolo
                            sv: 'Fumarsyra', // Svedese
                            hu: 'Fumársav' // Ungherese
                        }
                    }
                }
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            makeList(el) {
                let list = '';
                el.forEach(subel => {
                    list += this.ingredients[subel.key].label[this.lang] + ', '
                })
                return list.substring(0, list.length-2)
            },
            translateUrl(lang) {
                if(lang == 'en') {
                    return window.location.href.replace('/it/', '/en/').replace('/vini/', '/wines/')
                }else{
                    return window.location.href.replace('/en/', '/it/').replace('/wines/', '/vini/')
                }
            }
        },
        computed: {
            productName() {
                return this.product['name'].replace('<br>', ' ')
            },
            nutritionalInformations() {
                if (this.combinationId) {
                    for (const combination of this.product.combinations) {
                        if (combination.code == this.combinationId && combination.nutritional_informations !== undefined) {
                            return combination.nutritional_informations;
                        }
                    }
                }
                return this.product.nutritional_informations;
            }
        }
    }

</script>

<style>

.bottle{
        max-width: 70%;
        width:100%;
        object-fit:contain;
        object-position: left bottom;
        height: auto;
    }

    @media (max-width:1279px) {
        .bottle{
            width: 600px;
        }
    }

    @media (min-width:1500px) {
        .bottle{
            max-width: 60%;
        }
    }

    body, html {
        letter-spacing: 1px;
    }

    h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1{
        font-weight: 700;
    }

    [alt="simbolo"] {
        filter: invert(1);
    }

    @media (min-width:1800px) {

        .recycle-block .h1-like-text{
            font-size: 3.5rem
        }
    }

    @media (max-width:1440px) {
        .recycle-block .h1-like-text{
            font-size: 3.5rem
        }
    }

    @media (max-width:1199px) {
        .recycle-block .h1-like-text{
            font-size: 3.5rem
        }
    }

    @media (max-width:991px) {
        .recycle-block .h1-like-text{
            font-size: 3.4rem
        }
    }

    @media (max-width:575px) {
        .recycle-block .h1-like-text{
            font-size: 2.7rem
        }
    }

    @media (max-width:430px) {
        .recycle-block .h1-like-text{
            font-size: 2.4rem
        }
    }

    .recycle-block p{
        max-width:70ch;
        padding-left:15px;
        padding-right: 15px;
    }

    .shop-single-item__content.recycle{
        max-width: 100%;
    }

    th span, td span, .table-mobile *{font-family: "europa", sans-serif;}

    .bg-gold{
        background-color:#b6975c;
    }

    @media (min-width: 1280px) {
        .ml-xl-0{
            margin-left: 0px !important
        }
    }

    .bg-lightgold{
        background-color: rgba(255, 255, 255, 0.06);
    }

    .h6{
        margin-bottom: 0px;
    }

    .table th{
        background: #000000;
    }

    .table td, .table th{
        border: 0px;
        vertical-align: middle;
    }

    .table td{
        background: transparent !important;
    }

    .table > tbody > tr:nth-of-type(odd) {
        background-color: transparent;
    }

    .table > tbody > tr:nth-of-type(even) {
        background-color: rgba(255, 255, 255, 0.06);
    }

    .shop-like-header__gold-text:after{
        display:none;
    }
    .shop-like-header__gold-text{
        border: 0px !important;
        padding: 0px;
    }

    @media (max-width: 767px){
        .gold-like-title {
            font-size: 1.3rem;
        }
    }

    .content-td{
        max-width: 65%;
    }

    .table-mobile{
        width: calc(100% - 30px);
        max-width: 400px;
    }

    @media (max-width: 420px) {
        .table-mobile{
            max-width: 420px;
        }
    }

    .align-control{
        text-align: center;
    }

    .justify-control{
        justify-content: center;
    }

    @media (min-width: 1200px) {
        .align-control{
            text-align: left;
        }
        .justify-control{
            justify-content: flex-start;
        }
    }

    .logo{
        height:25px;
        max-width: 90%;
    }

    hr:not([size]) {
        height: 1px;
        width: 100%;
        background: white;
        opacity: .2;
    }

    .font-normalized{
        font-family: "europa", sans-serif;
    }

</style>
